import { composeSelectors } from "seneca-common/utils/selectors/compose-selectors";

import SchoolInfoState from "../../models/SchoolInfoState";
import * as metaSelectors from "./meta";
import * as schoolInfoSelectors from "./schoolInfo";

export function getSchoolInfo(state: SchoolInfoState) {
  return state.schoolInfo;
}

export function getMeta(state: SchoolInfoState) {
  return state.meta;
}

export const {
  hasSchool,
  getSchoolId,
  getSchoolName,
  getSchoolLocalAuthority,
  getSchoolTown,
  isSchoolInternational,
  getSchoolMat,
  isSchoolPrivate,
  getSchoolUrn
} = composeSelectors(getSchoolInfo, schoolInfoSelectors);

export const {
  schoolInfoIsFetching,
  schoolInfoFetchSucceeded,
  schoolInfoFetchErrored,
  schoolInfoFetchFinished,
  schoolInfoNeedsFetching
} = composeSelectors(getMeta, metaSelectors);
